// extracted by mini-css-extract-plugin
export default {"container":"pageNotFound_container__0SqRv","header":"pageNotFound_header__3cIAz","content":"pageNotFound_content__oLqMb","image":"pageNotFound_image__nraMU"};